import React from 'react';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { initiateTendering } from 'src/tendering/business-logic/initiate-tendering';
import { BaseButton } from 'src/common/components/base-button';
import { styles } from './checkout-button-style';
import { Grid, SvgIcon, Typography } from '@material-ui/core';
import { ReactComponent as DrawerLimitSvg } from './media/blind-pickup.svg';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';

export const CheckoutButton: React.FC<CheckoutButtonProps> = ({
  disabled,
  total,
  currencyCode,
  text,
  tendering,
  drawerAlertIconActive,
  buttonHeight,
  isCustomerDisplay,
}: CheckoutButtonProps): JSX.Element => {
  const { showSidebar } = useResponsiveContext();
  const classes = styles({ tendering });

  return (
    <BaseButton
      disabled={disabled}
      onClick={initiateTendering}
      className={
        !isCustomerDisplay
          ? !showSidebar
            ? classes.checkoutButtonSmallForm
            : classes.checkoutButton
          : classes.checkoutButtonCustomerDisplay
      }
      data-testid='checkout-button'
      style={{ height: buttonHeight }}
    >
      <Grid
        container
        justifyContent={'space-between'}
        className={`${classes.checkoutButtonLabelContainer} ${
          isCustomerDisplay ? classes.checkoutButtonLabelCustomerContainer : ''
        }`}
        alignItems={'center'}
        data-testid='checkout-button-container'
      >
        <Grid
          item
          xs={6}
          className={classes.checkoutButtonText}
          data-testid='checkout-button-container-label'
        >
          {text}
        </Grid>
        <Grid style={{ flex: 1 }} item container data-testid='checkout-button-alert-container'>
          <Grid justifyContent='flex-end' alignItems='center' item container>
            <SvgIcon className={classes.drawerLimitIcon}>
              {drawerAlertIconActive && (
                <DrawerLimitSvg data-testid='checkout-button-drawer-alert-icon' />
              )}
            </SvgIcon>
          </Grid>
        </Grid>
        <Grid item data-testid='checkout-button-container-value'>
          <Typography variant='body1' className={`${classes.checkoutButtonText}`}>
            {convertCurrency(total, currencyCode)}
          </Typography>
        </Grid>
      </Grid>
    </BaseButton>
  );
};

interface CheckoutButtonProps {
  disabled?: boolean;
  total: number;
  currencyCode: string;
  text: string;
  tendering?: boolean;
  drawerAlertIconActive: boolean;
  buttonHeight?: string;
  isCustomerDisplay?: boolean;
}
